import { render, staticRenderFns } from "./app.vue?vue&type=template&id=57f24d9c&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f24d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f24d9c')) {
      api.createRecord('57f24d9c', component.options)
    } else {
      api.reload('57f24d9c', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=57f24d9c&scoped=true&", function () {
      api.rerender('57f24d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/venveo-slider/app.vue"
export default component.exports